export default {
    setLocation(state, locationId) {
        state.locationId = locationId;
    }
};
